// Write your code here
import {Component} from 'react'
import './index.css'

class FruitsCounter extends Component {
  state = {key1: 0, key2: 0}

  onClickingmango = () => {
    this.setState(prevState => ({key1: prevState.key1 + 1}))
  }

  onClickingbanana = () => {
    this.setState(prevState => ({key2: prevState.key2 + 1}))
  }

  render() {
    const {key1} = this.state
    const {key2} = this.state
    return (
      <div className="card1">
        <div className="card2">
          <h1>
            Bob ate {key1} mangoes {key2} bananas
          </h1>
          <div className="card3">
            <div className="card4">
              <img
                className="img1"
                src="https://assets.ccbp.in/frontend/react-js/mango-img.png"
                alt="mango"
              />
              <br />
              <button
                type="button"
                className="button1"
                alt="cursor:pointer"
                onClick={this.onClickingmango}
              >
                Eat Mango
              </button>
            </div>
            <div className="card4">
              <img
                className="img1"
                src="https://assets.ccbp.in/frontend/react-js/banana-img.png"
                alt="banana"
              />
              <br />
              <button
                type="button"
                className="button1"
                alt="cursor:pointer"
                onClick={this.onClickingbanana}
              >
                Eat Banana
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default FruitsCounter
